import { useStats } from "./hooks/useStats";
import Header from "../components/Header";
import CustomPieChart from "./components/CustomPieChart";
import StatsCard from "../../../components/StatsCard";

import { PiStudentDuotone } from "react-icons/pi";
import { GiTeacher } from "react-icons/gi";
import { GiTakeMyMoney } from "react-icons/gi";
import usePermission from "./../../../hooks/usePermission";

function DashboardStats() {
    const { can } = usePermission();

    const { stats, isPending } = useStats();

    let pagesLinks = [
        {
            name: "الأحصائيات",
            link: `/admin/dashboard`,
        },
        { name: "الصفحة الرئيسية", link: `/` },
    ];

    if (isPending) return null;

    const {
        soldLecturesCount,
        studentCountByGrade: {
            secondary_grade_3,
            high_grade_1,
            high_grade_2,
            high_grade_3
        },
        lectureCountSecondary,
        lectureCountHigh,
        studentCountHigh,
        studentCountSecondary
    } = stats


    const studentsStats = [
        {
            name: "طلاب الصف الثالث الاعدادي",
            data: secondary_grade_3,
            color: "#ffaa00",
        },
        {
            name: "طلاب الصف الأول الثانوي" ,
            data: high_grade_1,
            color: "#ffaa00",
        },
        {
            name: "طلاب الصف الثاني الثانوي" ,
            data: high_grade_2,
            color: "#7a869a",
        },
        {
            name: "طلاب الصف الثالث الثانوي",
            data: high_grade_3,
            color: "#172b4d",
        },
    ];


    const lecturesStats = [
        {
            name: "محاضرات المرحله الاعداديه",
            data: lectureCountSecondary,
            color: "#1C1678",
        },
        {
            name: "محاضرات المرحله الثانويه",
            data: lectureCountHigh,
            color: "#15F5BA",
        },
    ];


    const totalStudents =
        studentCountHigh +
        studentCountSecondary;
    
    const totalLectures =
        lectureCountHigh +
        lectureCountSecondary;
    
    return (
        <div>
            <Header
                pageName="الأحصائيات"
                pages={pagesLinks}
                className="text-2xl"
            />

            <section className="flex flex-wrap justify-center gap-10 py-16">
                {can("read:users") && (
                    <StatsCard
                        title="مجموع الطلاب"
                        icon={<PiStudentDuotone className="text-6xl" />}
                        data={`${totalStudents} طلاب`}
                    />
                )}

                {can("read:course:lectures") && (
                    <StatsCard
                        title="مجموع المحاضرات المباعه"
                        icon={
                            <GiTakeMyMoney className="text-6xl text-green-800" />
                        }
                        data={`${soldLecturesCount} محاضره`}
                    />
                )}

                {can("read:course:lectures") && (
                    <StatsCard
                        title="مجموع المحاضرات"
                        icon={
                            <GiTeacher className="text-6xl text-primary-color-primary" />
                        }
                        data={`${totalLectures} محاضره`}
                    />
                )}

            </section>
            <section className="flex flex-wrap justify-around py-16 gap-x-5 gap-y-20">
                {can("read:users") && (
                    <CustomPieChart data={studentsStats} title="الطلاب" />
                )}
                {can("read:course:lectures") && (
                    <CustomPieChart data={lecturesStats} title="المحاضرات" />
                )}
            </section>
        </div>
    );
}

export default DashboardStats;
